export default __webpack_public_path__ + "static/media/02_Blauwe brug_1-huidige situatie.37a5a1b3.jpg";